import React, { useEffect, useState } from "react";

import {
  PotreeControlContainer,
  ToggleButtonContainer,
  InnerScrollContainer,
} from "../styled/potree/PotreeControl.styles";
import {
  PestControlIcon,
  RidgeFormingIcon,
  TransportIcon,
} from "../../assets/icons/WorkTypeIcons";

import { usePathStore, usePointStore } from "../../Store/store";
import Pathgenerate from "./Pathgenerate";
import Pathselect from "./Pathselect";
import Overlay from "./Overlay";
import { handleObstacleReset, handlePathReset } from "./PathRemove_Create";
import HideMenuButton from "../layout/HideMenuButton";
import { usePathModeStore, usePotreeStore } from "../../Store/PotreeStore";

export default function PotreeControl() {
  const [selectedWorkType, setSelectedWorkType] = useState("transport");
  const { setSelectionMode } = usePointStore();
  // localStorage에서 저장된 탭 상태 읽기 (없으면 기본값 "pathGenerate")
  const [toggleButton, setToggleButton] = useState(() => {
    const savedTab = localStorage.getItem("potreeControlTab");
    return savedTab || "pathGenerate";
  });
  const [isHidden, setIsHidden] = useState(false);
  const { setOverlayMessage, showOverlay, setShowOverlay, equipmentPaths } =
    usePathStore();
  const {
    setMarkers,
    setNodes,
    setEdges,
    setRibbonMeshs,
    setPolyline,
    setRibbonMesh,
    setPathGenerateMode,
    setPathEditMode,
    setAllObstaclePoints,
    setClosedObstacleArea,
    resetEquipmentPath,
    selectedEquipmentId,
  } = usePathStore();
  const { viewer } = usePathStore();
  const { potreeViewer } = usePotreeStore();
  const { SelectionGenerateMode, setSelectionGenerateMode } =
    usePathModeStore();

  useEffect(() => {
    if (showOverlay) {
      // 오버레이가 표시될 때
      // 전체 페이지 스크롤을 맨 위로
      window.scrollTo(0, 0);

      // 컨트롤바 스크롤도 맨 위로 (컨트롤바 클래스명에 맞게 수정)
      const controlContainer = document.querySelector(".InnerScrollContainer");
      if (controlContainer) {
        controlContainer.scrollTop = 0;
      }

      document.body.style.overflow = "hidden";
      if (controlContainer) {
        controlContainer.style.overflow = "hidden";
      }
    } else {
      document.body.style.overflow = "auto";
      const controlContainer = document.querySelector(".InnerScrollContainer");
      if (controlContainer) {
        controlContainer.style.overflow = "auto";
      }
    }
  }, [showOverlay]);

  // const handleStartPointClick = () => {
  //   setShowOverlay(!showOverlay);
  //   setSelectionMode("start");
  //   setOverlayMessage("출발 지점을 클릭해주세요.");
  // };

  // const handleEndPointClick = () => {
  //   setShowOverlay(!showOverlay);
  //   setSelectionMode("end");
  //   setOverlayMessage("도착 지점을 클릭해주세요.");
  // };

  // 씬 오브젝트 정리 함수
  const handleToggleButton = (mode) => {
    // 탭 상태를 먼저 localStorage에 저장
    localStorage.setItem("potreeControlTab", mode);

    // 탭 상태 업데이트 (UI 반영)
    if (mode === "pathGenerate") {
      setToggleButton("pathGenerate");
    } else if (mode === "pathSelect") {
      setToggleButton("pathSelect");
    }

    // 약간의 지연 후 포인트 클라우드 초기화 (탭 전환이 먼저 일어나도록)
    setTimeout(() => {
      window.location.reload();
    }, 50);
  };

  // 컴포넌트 마운트 시 저장된 탭 상태 복원
  useEffect(() => {
    const savedTab = localStorage.getItem("potreeControlTab");
    if (
      savedTab &&
      (savedTab === "pathGenerate" || savedTab === "pathSelect")
    ) {
      setToggleButton(savedTab);
      // 복원 후 localStorage 정리 (다음 탭 전환을 위해)
      localStorage.removeItem("potreeControlTab");
    }
  }, []);
  return (
    <PotreeControlContainer
      className={`potree-control-container ${isHidden ? "hidden" : ""}`}
    >
      <HideMenuButton isHidden={isHidden} setIsHidden={setIsHidden} />
      <InnerScrollContainer className="InnerScrollContainer">
        <ToggleButtonContainer>
          <button
            onClick={() => handleToggleButton("pathGenerate")}
            className={toggleButton === "pathGenerate" ? "active" : ""}
          >
            경로 생성
          </button>
          <button
            onClick={() => handleToggleButton("pathSelect")}
            className={toggleButton === "pathSelect" ? "active" : ""}
          >
            경로 선택
          </button>
        </ToggleButtonContainer>
        {toggleButton === "pathGenerate" ? (
          <Pathgenerate isHidden={isHidden} setIsHidden={setIsHidden} />
        ) : (
          <Pathselect />
        )}

        {showOverlay && <Overlay />}
      </InnerScrollContainer>
    </PotreeControlContainer>
  );
}
